/**
 * All {@link ProductItemState} values from inventory service (order matches backend enum).
 */
export const PRODUCT_ITEM_STATE_KEYS: string[] = [
  "CREATED",
  "IN_STOCK",
  "RESERVED",
  "SOLD",
  "DAMAGED",
  "EXPIRED",
  "LOST",
  "CONSUMED",
  "DELETED"
];
